export default __webpack_public_path__ + "146a8a24772b9d5a82a3faf0a5fa5fdb.webp";